<template>
  <div class="single-container" v-if="notDeleted">
    <div class="image-container">
      <router-link :to="{name: 'model.username', params: {username: '@'+data.user.username}}">
        <UserIcon :imageUrl="imageUrl" :logged="true" />
      </router-link>
    </div>

    <div class="comment-container">
      <div class="content-container">
        <div class="username-container">
          <router-link :to="{name: 'model.username', params: {username: '@'+data.user.username}}">
            {{ data.user.username }}
          </router-link>
          <!-- <span>{{ data.published_at }}</span> -->
          <div
            class="comment-options dropdown-container"
            v-if="showOptionsBar"
            @mouseleave="hideOptions"
          >
            <div
              class="dropdown-fake-container"
              :class="{ active: showOptions }"
            >
              <div
                class="dropdown-btn icon fa-lg fas"
                :class="{ active: showOptions }"
                aria-hidden="true"
                @click="toggleOptions"
              ></div>
            </div>
            <div v-if="showOptions" class="dropdown-items">
              <div class="item" @click="handleDeleteComment">
                <template v-if="!deleteCommentInstance">
                  {{ $t("comments.options.delete") }}
                </template>
                <template v-else>
                  {{ $t("comments.options.confirm_delete") }}
                </template>
              </div>
            </div>
          </div>
        </div>
        <span v-html="message"></span>
        <span class="reply-container" @click="raiseReply">
          {{ $t("comments.placeholder.respond") }}
        </span>
      </div>

      <div
        class="replies-container"
        v-if="!nested"
      >
        <ReplyList
          ref="replyList"
          :post="post"
          :model="model"
          :commentId="data.id"
          :replies="data.replies"
          @delete="deleteNestedComment"
          @reply="raiseNestedReply"
          @changeHeight="$emit('changeHeight')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UserIcon from "./UserIcon.vue";
import ReplyList from "./ReplyList.vue";
import resources from "../../resources";
import Cache from "../../modules/Cache";

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleOptions() {
      this.showOptions = !this.showOptions;

      if (!this.showOptions) this.resetOptionsConfig();
    },
    hideOptions() {
      this.showOptions = false;

      if (!this.showOptions) this.resetOptionsConfig();
    },
    resetOptionsConfig() {
      this.deleteCommentInstance = false;
    },
    genericRaiseReply(comment) {
      if (this.nested) {
        this.$emit("reply", comment);
        return;
      }

      this.$emit("reply", {
        comment: comment,
        cb: (comment) => {
          this.$refs.replyList.appendComment(comment);
          this.$emit("changeHeight");
        },
      });
    },
    raiseReply() {
      this.genericRaiseReply(this.data);
    },
    raiseNestedReply(data) {
      if (!this.nested) {
        data["id"] = this.data.id;
      }

      this.genericRaiseReply(data);
    },
    handleDeleteComment() {
      if (this.deleteCommentInstance) {
        this.deleteComment();
        return;
      }

      this.deleteCommentInstance = true;
    },
    deleteComment() {
      resources.comments
        .deleteComment(this.data.id)
        .then((response) => {
          if (!response.data.success) return;
          this.notDeleted = false;
          this.$emit("delete", this.data.id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteNestedComment() {
      this.data.replies -= 1;
    },
  },
  computed: {
    imageUrl() {
      // return resources.user.getProfilePicURL(this.data.user.profile_picture);
      return this.data.user.profile_picture;
    },
    user() {
      const user = Cache.getUserData();
      return user;
    },
    showOptionsBar() {
      return (
        this.data.user.chat_id === this.user.chat_id ||
        this.model.id === this.user.model_id
      );
    },
    message() {
      return this.data.message.replace(
        /@([a-zA-Z0-9_-]+)/g,
        '<span class="reply-to">$&</span>'
      );
    },
  },
  data() {
    return {
      showOptions: false,
      notDeleted: true,
      deleteCommentInstance: false,
    };
  },
  components: { UserIcon, ReplyList },
  name: "CommentSingle",
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.single-container {
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-block: 0 1em;

  .image-container {
    margin-right: 1em;
  }
}

.comment-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-block: unset;
  flex-grow: 1;

  $COLOR: var(--pallete_dark_text_color);

  .replies-container {
    display: flex;
    flex-direction: column;
    margin-top: 1em;
    width: 100%;

    > .replies-show-btn {
      display: flex;
      flex-direction: row;
      font-size: 0.9em;
      font-weight: 500;
      color: $COLOR;

      -webkit-tap-highlight-color: transparent;
      background: none;

      > .replies-decorator {
        height: 1px;
        width: 2.5em;
        border-top: 1px solid $COLOR;
        margin-block: auto;
        margin-right: 0.5em;
      }
    }
  }

  .content-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    .reply-container {
      font-size: 0.9em;
      font-weight: 500;
      color: $COLOR;
      width: fit-content;
      // color: $pallete_primary_color;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      -webkit-tap-highlight-color: transparent;
      background: none;
    }
  }
}

.username-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  a {
    font-size: 1em;
    margin: 0;
    font-weight: bold;
  }

  span {
    font-size: 0.8em;
    margin-left: 0.5em;
    margin-block: auto;
  }
}

.comment-options {
  align-self: center;
  margin-right: 1em;

  .icon {
    width: 20px;
    height: 20px;
    padding-bottom: 0.75em;
    padding-inline: 0.5em;
    background-image: url("/img/btn/three-dots.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
}

.dropdown-container {
  position: relative;
  right: 0%;

  .item,
  .dropdown-fake-container.active {
    min-width: 150px;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    padding-block: 0.75em;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 60);
    }

    &:hover {
      background-color: lighten(#000000, 75);
    }
  }

  .item {
    display: block;
  }

  .dropdown-fake-container {
    display: flex;
    justify-content: end;

    &.active {
      padding-block: 0em;
      background-color: unset !important;
    }
  }

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 9;
    background: lighten(#000000, 90);

    &:hover {
      cursor: pointer;
    }

    &::selection {
      background: none;
    }
  }
}
</style>

<style lang="scss">
@import "../../styles/variables.scss";

.comment-container > .content-container > span {
  margin-right: 40px;
  overflow-wrap: anywhere;

  > .reply-to {
    color: var(--pallete_main_color);
  }
}
</style>
